module.exports = {
      id: "search-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#search",
      toString: function () {
        return this.url;
      }
    }